/**
 * The panel's own marker for a composer chip's popover trigger, set by `WorkspaceAgentReferencePill` and
 * read back by the composer keymap: a primitive's ARIA moves when the primitive is swapped, and the remove
 * button in the same node would answer to it. Shared so a rename cannot break Enter/Space on a chip.
 */
export const WORKSPACE_AGENT_PILL_TRIGGER_ATTRIBUTE = 'data-workspace-agent-pill-trigger';
